// @ts-check
export const STATUS_OK = 'OK';

/** @type {import('./get-settings').CommerceConnectorOptions} */
export const options = {
  useZipCode: true,
  enableEmptyZipCode: true,
  zipCodeLength: 20,
  zipCodePattern: /.*/,
  searchOnOpen: true,
  closeOnEsc: true,
  detectZipCode: true,
  showRedirectWarning: false,
  isB2C: false
};
